import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const FilterSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.76369 22.7208C10.0089 22.838 10.269 22.8962 10.5272 22.8962C10.9188 22.8962 11.3054 22.7637 11.6259 22.5051L13.902 20.6773C14.7496 19.9971 15.2356 18.9839 15.2356 17.8964V11.5979L21.9276 6.57389C22.8624 5.87126 23.2276 4.70142 22.8575 3.59155C22.4879 2.48257 21.493 1.76562 20.3236 1.76562H3.67639C2.507 1.76562 1.51214 2.48257 1.14248 3.59155C0.772371 4.70142 1.13756 5.87126 2.07245 6.57389L8.76436 11.5979V21.1338C8.76436 21.8176 9.14744 22.4254 9.76369 22.7208ZM3.17337 5.10778C2.72494 4.77124 2.83638 4.3058 2.88113 4.17155C2.92588 4.03729 3.11608 3.59871 3.67639 3.59871H20.3236C20.8839 3.59871 21.0741 4.03729 21.1189 4.17155C21.1636 4.3058 21.2751 4.77124 20.8266 5.10778L13.7686 10.4065C13.5382 10.5793 13.4026 10.8514 13.4026 11.1396V17.8964C13.4026 18.4254 13.1663 18.9177 12.7545 19.2488L10.5974 20.9808V11.1396C10.5974 10.8514 10.4618 10.5793 10.2314 10.4065L3.17337 5.10778Z'
      fill='currentColor'
    />
  </svg>
);

export const FilterIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FilterSvg} color='#ADC8B6' {...props} />
);
